module.exports = '1.1.5';



//////////////////
// WEBPACK FOOTER
// /home/jenkins/workspace/production-argos-front/argos/node_modules/sockjs-client/lib/version.js
// module id = WkGo
// module chunks = 5